import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { MdSentimentDissatisfied } from 'react-icons/md';

const ErrorMessage = ({ source = 'data', extra = '' }) => {
  return (
    <Box
      py={4}
      textAlign="center"
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
    >
      <MdSentimentDissatisfied size={32} color="#8F9BBA" />
      <Text color="#8F9BBA">
        No {source} found {extra}
      </Text>
    </Box>
  );
};

export default ErrorMessage;
